import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import * as Sentry from '@sentry/ember';

type Options = {
  key: string;
};

export async function initializeGoogleMaps(options: Options): Promise<void> {
  const { key } = options;

  setOptions({
    key,
    v: 'quarterly',
  });

  try {
    await importLibrary('places');
  } catch (error) {
    // Most google maps issues are because they are blocked in certain regions
    // This just helps us format the error a little
    console.log(error);
    Sentry.captureException('Google maps failed to load');
  }
}
